
define('text!common/views/content/richLinkTag.html',[],function () { return '<aside class="element element-rich-link element-rich-link--tag element--thumbnail element-rich-link--not-upgraded" data-component="rich-link-tag" data-link-name="rich-link-tag">\n    <p><a href="<%=href%>"><%=href%></a></p>\n</aside>\n';});

